import { Base64 } from "js-base64";
import React, { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { AppContext } from "../../components/AppProvider";
import { AlertLayer } from "../../components/UI/Dialog";
import { InputDivWithComment } from "../../components/UI/INPUT/InputDivWithComment";
import {
  PostApi102,
  PostApi150,
  PostApi151,
} from "../../modules/network/padoPost";
import { PwdCheck, checkEngA, checkKor } from "../../modules/utils/CheckLogic";
import { getCookie, setCookie } from "../../modules/utils/cookie";
import { ContainerNew, SubMenu, openLayerFn } from "../Layout";
import { ExistIdLayer } from "../common/Modal/ExistIdLayer";
import { checkSpc } from "./../../modules/utils/CheckLogic";

import IconEyeOff from "../../resources/images/icon/login/Icon feather-eye-off.svg";
import IconEyeOn from "../../resources/images/icon/login/Icon feather-eye.svg";
import { handleRequest101, password } from "./loginHandler";
import useTitle from "../../modules/hooks/useTitle";

export default (props) => {
  const { phonecfg, cfg, dispatch } = useContext(AppContext);
  useTitle("회원가입_계정생성");
  const [inputIdStatus, setInputIdStatus] = useState("I");
  const [idErrorText, setIdErrorText] = useState("");
  const [inputPwStatus, setInputPwStatus] = useState("I");
  const [pwErrorText, setPwErrorText] = useState("");
  const [inputPwStatusRe, setInputPwStatusRe] = useState("I");
  const [pwErrorTextRe, setPwErrorTextRe] = useState("");
  const [loginSuccess, setLoginSuccess] = useState(false);

  const [alertText, setAlertText] = useState();
  const [dupList, setDupList] = useState("");

  const [eye, setEye] = useState(props.match.params.mode === "auto" ? true : false);
  const [msgYn, setMsgYn] = useState(props.match.params.mode === "auto" ? "Y" : "N");
  const [pwImpact, setPwImpact] = useState(false);
  const [rePwImpact, setRePwImpact] = useState(false);

  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
    url: "",
  });

  const handleAlert = (title, msg, movePage) => {
    setDialog({
      title: title,
      msg: msg,
      url: movePage ? movePage : "",
    });

    openLayerFn($(".alert-layer"));
  };

  const bottom = (
    <div
      className="under-fix-btnarea"
      style={{ textAlign: "center", margin: "0px 15px", width: "auto" }}
    >
      <BtnNext
        innerWidth={window.innerWidth}
        onClick={() => {
          registAction();
        }}
      >
        회원가입
      </BtnNext>
    </div>
  );

  // blur 처리일때 동작
  const checkPassword = (status, password) => {
    setMsgYn("N");
    setInputPwStatus(status);
    // 비밀번호 규칙에 맞을때
    if ($("input[name=password]").val().length >= 5) {
      if (!PwdCheck(password)) {
        setInputPwStatus("PE");
        setPwErrorText("비밀번호는 5~18자의 영문소문자, 숫자 조합입니다.");
      } else {
        if ($("input[name=password]").val() != "" && $("input[name=passwordCheck]").val() != "") {
          if ($("input[name=password]").val() == $("input[name=passwordCheck]").val()) {
            setInputPwStatusRe("G");
            setPwErrorTextRe("사용 가능한 비밀번호입니다.");
            setInputPwStatus("G");
            setPwErrorText("사용 가능한 비밀번호입니다.");
          } else {
            setInputPwStatusRe("PRE");
            setPwErrorTextRe("비밀번호가 일치하지 않습니다.");
          }
        }
      }
    }
  };

  const checkRePassword = (status, password) => {
    setMsgYn("N");
    setInputPwStatus(status);
    // 비밀번호 규칙에 맞을때
    if ($("input[name=passwordCheck]").val().length >= 5) {
      if (!PwdCheck(password)) {
        setInputPwStatusRe("PE");
        setPwErrorTextRe("비밀번호는 5~18자의 영문소문자, 숫자 조합입니다.");
      } else {
        if ($("input[name=password]").val() != "" && $("input[name=passwordCheck]").val() != "") {
          if ($("input[name=password]").val() == $("input[name=passwordCheck]").val()) {
            setInputPwStatusRe("G");
            setPwErrorTextRe("사용 가능한 비밀번호입니다.");
            setInputPwStatus("G");
            setPwErrorText("사용 가능한 비밀번호입니다.");
          } else {
            setInputPwStatusRe("PRE");
            setPwErrorTextRe("비밀번호가 일치하지 않습니다.");
          }
        }
      }
    }
  };

  const checkIdDup = () => {
    if (checkKor.test($("input[name='ID']").val().trim())) {
      setInputIdStatus("E");
      setIdErrorText("오류: 아이디는 한글을 사용할 수 없습니다.");
      return false;
    } else if (checkSpc.test($("input[name='ID']").val().trim())) {
      setInputIdStatus("E");
      setIdErrorText("오류: 아이디는 특수문자를 사용할 수 없습니다.");
      return false;
    } else if (checkEngA.test($("input[name='ID']").val().trim())) {
      setInputIdStatus("E");
      setIdErrorText("오류: 아이디는 영어 대문자를 사용할 수 없습니다.");
      return false;
    } else if ($("input[name='ID']").val().trim().length < 5) {
      setInputIdStatus("E");
      setIdErrorText("오류: 영어소문자, 숫자 5자 이상을 입력하세요");
      return false;
    } else {
      PostApi151(phonecfg, cfg, $("input[name='ID']").val().trim())
        .then(res => {
          if (res.resultCode === "000") {
            if (res.resultList.length > 0) {
              setInputIdStatus("E");
              setIdErrorText("이미 사용중인 계정입니다.");
              // setAlertText("이미 사용중인 계정입니다.");
              return false;
            } else {
              setInputIdStatus("G");
              setIdErrorText("사용 가능한 계정입니다.");
              return true;
            }
          }
        })
        .catch(err => {
          console.log("서버오류 : ", err);
          // setAlertText("서버 오류입니다");
          return false;
        });
    }
  };

  const checkIdValue = () => {
    if (checkKor.test($("input[name='ID']").val().trim())) {
      setInputIdStatus("E");
      setIdErrorText("오류: 아이디는 한글을 사용할 수 없습니다.");
      return false;
    } else if (checkSpc.test($("input[name='ID']").val().trim())) {
      setInputIdStatus("E");
      setIdErrorText("오류: 아이디는 특수문자를 사용할 수 없습니다.");
      return false;
    } else if (checkEngA.test($("input[name='ID']").val().trim())) {
      setInputIdStatus("E");
      setIdErrorText("오류: 아이디는 영어 대문자를 사용할 수 없습니다.");
      return false;
    } else if ($("input[name='ID']").val().trim().length < 5) {
      setInputIdStatus("E");
      setIdErrorText("오류: 영어소문자, 숫자 5자 이상을 입력하세요");
      return false;
    }
    return true;
  };

  //
  const request102 = () => {
    const userInfo = JSON.parse(Base64.decode(props.match.params.info));

    PostApi150(cfg, userInfo.userDI)
      .then((res) => {
        if (res.resultList.length > 0) {
          setDupList(res.resultList);
          handleDuplicateMember();
        } else {
          PostApi102(
            phonecfg,
            cfg,
            $("input[name=ID]").val().trim(),
            password($("input[name=ID]").val().trim(), $("input[name=password]").val()),
            userInfo.userName,
            props.match.params.mode === "auto" ? "500" : "000",
            userInfo,
            msgYn,
            userInfo.isForeigner ? userInfo.isForeigner : 0
          )
            .then((res) => {
              if (res.resultCode === "000") {
                if (res.result === 1) {
                  // 회원가입 성공 이후 로그인 처리
                  handleRequest101(
                    phonecfg,
                    cfg,
                    dispatch,
                    setLoginSuccess,
                    $("input[name=ID]").val(),
                    $("input[name=password]").val(),
                    "000",
                    // props.match.params.mode === "auto" ? "500" : "000",
                    handleAlert
                  );
                  // handleAlert("확인", `케어포미에 오신 것을 환영합니다.`, "/membership/login");
                } else {
                  handleRegistError();
                }
              } else {
                if (res.result === 0) {
                  handleDuplicateMember();
                } else if (res.result === -1) {
                  handleDuplicateId();
                } else if (res.result === -2) {
                  handlePhoneTokenNotExist();
                } else if (res.result === -3) {
                  handleEmailNotExist();
                } else if (res.result === -4) {
                  handlePasswordNotExist();
                } else {
                  handleRegistError();
                }
              }
            })
            .catch((err) => {
              console.log("err: ", err);
            });
        }
      })
      .catch((err) => {
        console.log("Err :: ", err);
      });
  };

  const checkInputEmpty = () => {
    //ID, password, passwordCheck
    if ($("input[name=ID]").val() == "") {
      setInputIdStatus("E");
      setIdErrorText("아이디를 입력하세요.");
      return false;
    }
    if ($("input[name=password]").val() == "") {
      setInputPwStatus("E");
      setPwErrorText("비밀번호를 입력하세요.");
      return false;
    }
    if ($("input[name=passwordCheck]").val() == "") {
      setInputPwStatusRe("E");
      setPwErrorTextRe("2차 비밀번호를 입력하세요.");
      return false;
    }
    return true;
  };

  const checkPwAvailable = () => {
    if ($("input[name=password]").val() != $("input[name=passwordCheck]").val()) {
      setInputPwStatusRe("E");
      setPwErrorTextRe("비밀번호가 일치하지 않습니다.");
      return false;
    }

    if (props.match.params.mode === "auto") {
    } else {
      if (
        !PwdCheck($("input[name=password]").val()) ||
        !PwdCheck($("input[name=passwordCheck]").val())
      ) {
        setInputPwStatus("E");
        setPwErrorText("유효하지 않은 비밀번호 입니다. (5자 이상 영문소문자, 숫자)");
        return false;
      }
    }

    return true;
  };

  const registAction = () => {
    // 빈값 체크
    // 아이디 중복체크
    // 비밀번호 유효성 체크
    // 회원가입
    if (checkInputEmpty()) {
      if (checkPwAvailable()) {
        if (checkIdValue()) {
          request102();
        }
      }
    }
  };

  const handleDuplicateMember = (userId) => {
    // let viewId;
    // viewId = userId.split("@");
    // handleAlert('회원가입', '이미 등록된 회원입니다.<br />' + viewId[0].slice(0, -2) + '**'  + '@' + viewId[1], '/membership/login');
    // openLayerFn($("#existLayer"));
    handleAlert("회원가입", "중복 등록된 ID 입니다.");
  };
  const handleDuplicateId = () => {
    handleAlert("회원가입", "중복 등록된 ID 입니다.");
  };
  const handlePhoneTokenNotExist = () => {
    handleAlert("회원가입", "폰토큰 값이 없습니다.");
  };
  const handleEmailNotExist = () => {
    handleAlert("회원가입", "이메일이 없습니다.");
  };
  const handlePasswordNotExist = () => {
    handleAlert("회원가입", "비밀번호가 없습니다.");
  };
  const handleRegistError = () => {
    handleAlert("회원가입", "회원가입 실패하였습니다.");
  };

  const toggleEyeEvent = () => {
    if (eye) {
      setEye(false);
    } else {
      setEye(true);
    }
  };

  useEffect(() => {
    if (props.match.params.mode === "manual") {
      if (props.match.params.info) {
        let userInfo = JSON.parse(Base64.decode(props.match.params.info));
        setCookie("userInfo", userInfo, 1);

        let signUpChannel = getCookie("signUpChannel");

        // request150(userInfo.userDI, userInfo.userName.trim(), signUpChannel);
        // $("#userName").val(userInfo.userName.trim());
      }
    } else {
      let userInfo = getCookie("userInfo");
    }
  }, [props.match.params.info]);

  const openWebSocket = () => {
    // socketManager(SocketCommand.GET_PHONE_INFO, undefined);
    // if (phonecfg.phoneOS == "IOS") {
    //   socketManager(SocketCommand.GET_GPS_INFO, undefined);
    // }
  };

  const onChangeIdEvent = (status) => {
    setMsgYn("N");
    setInputIdStatus(status);
  };

  useEffect(() => {
    if (phonecfg.phoneToken == "123" || phonecfg.version == "2.0.0") {
      openWebSocket();
    }
  }, [phonecfg]);

  useEffect(() => {
    if (props.match.params.mode === "auto") {
      let userInfo = JSON.parse(Base64.decode(props.match.params.info));
      // 아이디 자동생성 (전화번호 8자리 + 생일 4자리)
      // 비밀번호 자동생성 (생년월일 8자리);
      $("input[name=ID]").val(
        userInfo.userPhone + userInfo.userBirth.substring(4, userInfo.userBirth.length)
      );
      $("input[name=password]").val(userInfo.userBirth);
      $("input[name=passwordCheck]").val(userInfo.userBirth);
    }
  }, []);

  // state Y:정상 Err:에러
  const [checkIdState, setCheckIdState] = useState("Y");
  return (
    <Fragment>
      <ContainerNew
        Title={"본인인증"}
        dark={"dark"}
        leftMenu={SubMenu}
        rightMenu={-1}
        isMain={true}
      >
        <Contents>
          <SubTitle>계정생성</SubTitle>
          <div style={{ padding: "8px 0px" }}>
            {props.match.params.mode === "manual" ? (
              <p>케어포미 앱에서 사용하실 아이디와 비밀번호를 입력하세요</p>
            ) : (
              <Fragment>
                <p>입력하신 회원정보로 계정이 자동생성되었습니다.</p>
                <p>자동생성된 정보를 원하지 않으실 경우 직접 클릭하시고</p>
                <p>원하시는 계정정보를 입력하세요.</p>
              </Fragment>
            )}
          </div>

          {/* input area */}
          <div>
            {inputIdStatus == "I" || inputIdStatus == "G" ? (
              <DivTitle>아이디</DivTitle>
            ) : (
              <DivErrTitle style={{ color: "red" }}>아이디 | 영어소문자, 숫자 5자 이상</DivErrTitle>
            )}
            <InputDivWithComment
              type="text"
              name="ID"
              placeholder="아이디(5자 이상 영문소문자, 숫자)"
              focusEvent={setInputIdStatus}
              blurEvent={onChangeIdEvent}
              inputState={inputIdStatus}
              clickEvent={checkIdDup}
              errorText={idErrorText}
              style={{ paddingRight: "0px" }}
            />

            {!pwImpact ? (
              <DivTitle
                onClick={() => {
                  toggleEyeEvent();
                  setPwImpact(true);
                }}
              >
                비밀번호생성
              </DivTitle>
            ) : (
              <DivErrTitle
                onClick={() => {
                  toggleEyeEvent();
                  setPwImpact(false);
                }}
                style={{ color: "#6200EE" }}
              >
                비밀번호생성
              </DivErrTitle>
            )}
            <InputDivWithComment
              type={eye ? "text" : "password"}
              name="password"
              placeholder="비밀번호(5자 이상 영문소문자, 숫자)"
              maxLength={16}
              focusEvent={setInputPwStatus}
              blurEvent={checkPassword}
              onChange={checkPassword}
              inputState={inputPwStatus}
              clickEvent={toggleEyeEvent}
              errorText={pwErrorText}
              iconEye={eye ? IconEyeOn : IconEyeOff}
            />

            {!rePwImpact ? (
              <DivTitle
                onClick={() => {
                  setRePwImpact(true);
                }}
              >
                비밀번호확인
              </DivTitle>
            ) : (
              <DivErrTitle onClick={() => setRePwImpact(false)} style={{ color: "#6200EE" }}>
                비밀번호확인
              </DivErrTitle>
            )}
            <InputDivWithComment
              type="password"
              name="passwordCheck"
              placeholder="비밀번호(5자 이상 영문소문자, 숫자)"
              maxLength={16}
              focusEvent={setInputPwStatusRe}
              blurEvent={checkRePassword}
              onChange={checkRePassword}
              inputState={inputPwStatusRe}
              errorText={pwErrorTextRe}
              iconEye={IconEyeOff}
            />
          </div>

          <Bottom registAction={registAction} />
        </Contents>
      </ContainerNew>
      <AlertLayer title={dialog.title} msg={dialog.msg} url={dialog.url} />
      <ExistIdLayer dupList={dupList} />
    </Fragment>
  );
};

const Bottom = ({ registAction }) => {
  const style = {
    position: "absolute",
    left: "0",
    height: "58px",
    boxShadow: "0px -2px 5px 0 rgba(0,0,0,0.15)",
    textAlign: "center",
    margin: "0px 15px",
    width: "auto",
  };
  return (
    <div style={style}>
      <BtnNext
        innerWidth={window.innerWidth}
        onClick={() => {
          registAction();
        }}
      >
        회원가입
      </BtnNext>
    </div>
  );
};

const Contents = ({ children }) => {
  return (
    <div className="contents">
      <div className="sub-contents">{children}</div>
    </div>
  );
};

const SubTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-top: 37px;
`;

const BtnNext = styled.div`
  bottom: 86px;
  width: ${(props) => window.innerWidth - 30}px;
  height: 50px;
  line-height: 50px;
  background: #000000 0% 0% no-repeat padding-box;
  color: #fff;
  border-radius: 4px;
  opacity: 1;
  font-size: 17px;
`;

const DivTitle = styled.div`
  padding-left: 7px;
  font-weight: 700;
`;

const DivErrTitle = styled.div`
  padding-left: 7px;
  font-weight: 700;
`;
